<template>
    <v-layout wrap align-center>
        <v-flex xs12>
            <select-label
                v-model="times"
                class="text-caption"
                :disabled="disabled"
                :rules="rulesData"
                :items="timesList"
                @focus="e => $emit('focus', e)"
                @blur="e => $emit('blur', e)"
            />
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { getLocale } from '../../translations';
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'TimePickerTextField',
    components: {
        SelectLabel,
    },
})
export default class TimePickerTextField extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: '' }) label: string;
    @Prop({ default: () => [] }) rules: [];
    @Prop({ default: () => [] }) timesList: [];

    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.times = val;
    }
    @Watch('times', { immediate: true })
    onTimesChanged(val: string): void {
        this.input(val);
    }
    @Emit()
    public input(value: string) {}

    times = '';

    get locale(): string {
        return getLocale().name;
    }
    get rulesData(): Array<any> {
        return this.rules;
    }
}
</script>
